import Vuelidate from 'vuelidate';
import * as Sentry from '@sentry/vue';
import {BrowserTracing} from '@sentry/tracing';
import {ready} from '../main/utils';
import Vue from '../main/vue';
import store from '../main/vue-store';
import router from './routes';
import App from './views/App.vue';

ready(() => {
  Vue.use(Vuelidate);

  if (window.location.origin === 'https://www.sloan.com') {
    Sentry.init({
      Vue,
      dsn: 'https://cdaf69a5d65e4a6faf97b9f387dbfebb@o4504453127340032.ingest.sentry.io/4504453128585216',
      tracesSampleRate: 1.0,
      denyUrls: [
        /marketo\.com/,
        /marketo\.net/,
        /googletagmanager\.com/,
        /google-analytics\.com/,
        /facebook\.com/,
        /facebook\.net/,
        /pinterest\.com/,
        /snap\.licdn\.com/,
        /srcspot\.com/,
        /zi-scripts\.com/,
        /pactsafe\.io/
      ],
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracePropagationTargets: ['localhost', 'www.sloan.com', /^\//]
        })
      ]
    });
  }

  new Vue({
    el: document.querySelector('#marketplace-root'),
    comments: true,
    store,
    router,
    template: '<App/>',
    components: {
      App
    }
  });
});
